// import React from "react";

// export const Navigation = (props) => {
//   return (
//     <nav id="menu" className="navbar navbar-default navbar-fixed-top">
//       <div className="container">
//         <div className="navbar-header">
//           <button
//             type="button"
//             className="navbar-toggle collapsed"
//             data-toggle="collapse"
//             data-target="#bs-example-navbar-collapse-1"
//           >
//             {" "}
//             <span className="sr-only">Toggle navigation</span>{" "}
//             <span className="icon-bar"></span>{" "}
//             <span className="icon-bar"></span>{" "}
//             <span className="icon-bar"></span>{" "}
//           </button>
//           <a className="navbar-brand page-scroll logo" href="#page-top">
//             <img className="com-logo" src="img/cradleai_gray.png"></img>
//           </a>{" "}
//         </div>

//         <div
//           className="collapse navbar-collapse"
//           id="bs-example-navbar-collapse-1"
//         >
//           <ul className="nav navbar-nav navbar-right">
//             {/* <li>
//               <a href="#features" className="page-scroll">
//                 Collaboration
//               </a>
//             </li> */}
//             <li>
//               <a href="/#" className="page-scroll">
//                 Home
//               </a>
//             </li>
//             {/* <li>
//               <a href="/#news" className="page-scroll">
//                 News
//               </a>
//             </li> */}
//             <li>
//               <a href="/#about" className="page-scroll">
//                 About
//               </a>
//             </li>
//             <li>
//               <a href="/#projects" className="page-scroll">
//                 Projects
//               </a>
//             </li>
//             {/* <li>
//               <a href="#portfolio" className="page-scroll">
//                 Gallery
//               </a>
//             </li> */}
//             {/* <li>
//               <a href="#testimonials" className="page-scroll">
//                 Testimonials
//               </a>
//             </li> */}
//             <li>
//               <a href="/#team" className="page-scroll">
//                 Team
//               </a>
//             </li>
//             {/* <li>
//               <a href="#contact" className="page-scroll">
//                 Contact
//               </a>
//             </li> */}
//           </ul>
//         </div>
//       </div>
//     </nav>
//   );
// };
import React, { useEffect, useState } from "react";
import {
  smoothScrollToElement,
  smoothScrollToPosition,
} from "../utils/scroll";

const navItems = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "team", label: "Team" },
  { id: "portfolio", label: "Collaboration" },
  { id: "contact", label: "Contact" },
  { id: "blog", label: "Blog", href: "#/blog" },
];

export const Navigation = () => {
  const [activeSection, setActiveSection] = useState("about");

  useEffect(() => {
    const sectionIds = navItems
      .map((item) => item.id)
      .filter((id) => document.getElementById(id));

    const updateActiveSection = () => {
      const menuHeight = document.getElementById("menu")?.offsetHeight || 0;
      const readingLine = window.scrollY + menuHeight + window.innerHeight * 0.28;
      let currentSection = sectionIds[0] || "about";

      sectionIds.forEach((id) => {
        const section = document.getElementById(id);
        if (section && section.offsetTop <= readingLine) {
          currentSection = id;
        }
      });

      setActiveSection(currentSection);
    };

    updateActiveSection();
    window.addEventListener("scroll", updateActiveSection, { passive: true });
    window.addEventListener("resize", updateActiveSection);

    return () => {
      window.removeEventListener("scroll", updateActiveSection);
      window.removeEventListener("resize", updateActiveSection);
    };
  }, []);

  const handleNavClick = (event, item) => {
    if (item.href) return;

    const target = document.getElementById(item.id);
    if (!target) return;

    event.preventDefault();
    setActiveSection(item.id);
    smoothScrollToElement(item.id, { menuId: "menu" });
  };

  const handleBrandClick = (event) => {
    if (!document.getElementById("header")) return;

    event.preventDefault();
    smoothScrollToPosition(0, 820);
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a
            className="navbar-brand page-scroll"
            href="#page-top"
            onClick={handleBrandClick}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src="./img/cradleai_logo.png" // Replace this path with the actual logo image path
              alt="CradleAI Logo"
              style={{
                height: "40px",
                // marginRight: "8px",
                display: "inline-block",
              }}
            />
            {/* CradleAI */}
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {navItems.map((item) => (
              <li
                className={activeSection === item.id ? "active" : ""}
                key={item.id}
              >
                <a
                  href={item.href || `#${item.id}`}
                  className="page-scroll"
                  aria-current={activeSection === item.id ? "page" : undefined}
                  onClick={(event) => handleNavClick(event, item)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};
